// Shared by data requests and foreground lazy imports. Background route imports
// deliberately do not register: they must never hold up the page's readiness.
let pending = 0
const listeners = new Set()

export const isPageLoading = () => pending > 0
export const subscribePageLoad = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export function beginPageLoad() {
    pending += 1
    listeners.forEach(listener => listener())
    let finished = false
    return () => {
        if (finished) return
        finished = true
        pending -= 1
        listeners.forEach(listener => listener())
    }
}

export function trackPageRequests(client) {
    const requests = new WeakMap()
    client.interceptors.request.use(config => {
        requests.set(config, beginPageLoad())
        return config
    })
    const finish = config => {
        requests.get(config)?.()
        requests.delete(config)
    }
    client.interceptors.response.use(response => {
        finish(response.config)
        return response
    }, error => {
        finish(error.config)
        return Promise.reject(error)
    })
}
